var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog',{staticClass:"loader",attrs:{"open":""}},[_c('progress',{staticClass:"loader-progress",attrs:{"max":"100","min":"0"},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }